import Enumerator from '../global/Enumerator';

export const assetFinanceAssetAges = ['none', 'new', 'used', 'demo', 'unsure'];

export class AssetFinanceAssetAge extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
      case 'New':
        correctOption = 'new';
        break;
      case '2':
      case 'Used':
        correctOption = 'used';
        break;
      case '3':
      case 'Demo':
        correctOption = 'demo';
        break;
      case '4':
      case 'Unsure':
        correctOption = 'unsure';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

AssetFinanceAssetAge.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  new: {
    get title() {
      return 'New';
    }
  },
  used: {
    get title() {
      return 'Used';
    }
  },
  demo: {
    get title() {
      return 'Demo';
    }
  },
  unsure: {
    get title() {
      return 'Unsure';
    }
  }
});

export default {
  assetFinanceAssetAges,
  AssetFinanceAssetAge
};
